import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, RadioCardOptionGroup } from '../../components';

import { ScreenHeader } from './new-hd-verify-personal-info-screen';

const options = [
  {
    id: 'yes',
    label: 'Yes',
    description: 'I am currently pregnant or may become pregnant and this may affect my healthcare decisions.',
    name: 'pregnancy',
    icon: 'pregnant_woman',
    value: 'yes'
  },
  {
    id: 'no',
    label: 'No',
    description: 'I am not currently pregnant nor may I become pregnant.',
    name: 'pregnancy',
    icon: 'person',
    value: 'no'
  }
];

export function NewHDPregnancyStatus() {
  const navigate = useNavigate();

  const [ error, setError ] = useState<string | null>(null);
    
  const handleBack = useCallback(() => {
    navigate('../verify');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    const selectedElement = document.querySelector('input[name="pregnancy"]:checked');

    if (!selectedElement) {
      setError('Please select a pregnancy status.');
      return;
    }

    const selectedOption = (selectedElement as HTMLInputElement).value;
    console.log('Selected pregnancy status:', selectedOption);

    navigate('../physician-information');
  }, [ navigate ]);

  return (
    <div className="new-ha-pregnancy-status">
      <ScreenHeader 
        title="Pregnancy Status"
        description="Is there a possibility that you are pregnant or may become pregnant?"
        steps={8}
        step={2}
        handleBack={handleBack}
      />
      
      <RadioCardOptionGroup options={options} />
      {error && <div className="error-message">{error}</div>}
      
      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}